// Shared reaction set for posts and comments
export const REACTIONS = [
  { type: "like", emoji: "👍" },
  { type: "love", emoji: "❤️" },
  { type: "haha", emoji: "😂" },
  { type: "wow", emoji: "😮" },
  { type: "sad", emoji: "😢" },
  { type: "dislike", emoji: "👎" },
];

export const emojiFor = (type) => (REACTIONS.find((r) => r.type === type) || {}).emoji;

export const topReactionEmojis = (counts = {}, n = 3) =>
  REACTIONS.filter((r) => (counts[r.type] || 0) > 0)
    .sort((a, b) => (counts[b.type] || 0) - (counts[a.type] || 0))
    .map((r) => r.emoji)
    .slice(0, n);
